import React from "react";
import { useEffect, useState } from "react";
import {
  CompanyManageGetAutoStock,
  CompanyManageGetStockAll,
  CompanyManageMyStore,
} from "../../Api/Services";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jalaali from "jalaali-js";
import imgPlus from "../../assets/Icon/execution.png";
import InputCus from "../../Component/InputCus/Text/InputCus";

function CompanyStoreStockAll() {
  const [isLoading, setLoading] = useState(true);
  const [CompanyStore, setCompanyStore] = useState({});
  const [Stores, setStores] = useState([]);
  const [Product, setProduct] = useState("");

  const handleDownload = () => {
    try {
      const wb = XLSX.utils.book_new();

      // --- ساخت header جدول ---
      const storeValues = Object.values(
        (Stores || []).reduce((acc, item) => {
          if (item && item.companyStoreCompanyId) {
            acc[item.companyStoreCompanyId] = item;
          }
          return acc;
        }, {}),
      );

      const headerRow1 = ["نام کالای", "رنگ"];
      const headerRow2 = ["", ""];

      storeValues.forEach((itemPro) => {
        const subStores = CompanyStore.companyStore.filter(
          (w) => w.companyId == itemPro.companyStoreCompanyId,
        );
        headerRow1.push(
          ...subStores.map(() => itemPro.companyStoreCompanyName),
          "مجموع شرکت",
        );
        headerRow2.push(...subStores.map((s) => s.name), "");
      });

      const sheetData = [headerRow1, headerRow2];

      // --- داده‌ها ---
      CompanyStore.productStock.forEach((itemPro) => {
        const parts = [
          itemPro.productProductBerandName != " " &&
            itemPro.productProductBerandName + " ",

          itemPro.productProductTypeName != " " &&
            itemPro.productProductTypeName + " ",

          itemPro.productProductSeriesName != " " &&
            itemPro.productProductSeriesName,

          itemPro.productSymbol,

          itemPro.productProductSeriesEndName != " "
            ? itemPro.productProductSeriesEndName + " "
            : " ",

          itemPro.productProductRamName != " " &&
            itemPro.productProductRamName + "/",

          itemPro.productProductRomName != " " &&
            itemPro.productProductRomName + " ",

          itemPro.productProductNetworkName != " " &&
            itemPro.productProductNetworkName + " ",

          itemPro.productProductCountryName != " " &&
            itemPro.productProductCountryName + " ",

          itemPro.productIsInsurance && "بیمه",
        ]
         

        let a = parts.filter(Boolean).join("");

        const row = [a, itemPro.productProductColorName];

        storeValues.forEach((ww) => {
          const subStores = CompanyStore.companyStore.filter(
            (w) => w.companyId == ww.companyStoreCompanyId,
          );
          subStores.forEach((ee) => {
            row.push(
              itemPro.stocks.find((w) => w.companyStoreId == ee.id)?.stock || 0,
            );
          });
          row.push(
            itemPro.stocks
              .filter((w) => w.companyId == ww.companyStoreCompanyId)
              .reduce((sum, x) => sum + x.stock, 0),
          );
        });

        sheetData.push(row);
      });

      // --- ردیف مجموع ---
      const totalRow = ["مجموع", ""];
      storeValues.forEach((ww) => {
        const subStores = CompanyStore.companyStore.filter(
          (w) => w.companyId == ww.companyStoreCompanyId,
        );
        subStores.forEach((ee) => {
          totalRow.push(
            CompanyStore.productStock
              .filter((ps) => ps.stocks.some((s) => s.companyStoreId == ee.id))
              .reduce(
                (sum, ps) =>
                  sum +
                  ps.stocks
                    .filter((s) => s.companyStoreId == ee.id)
                    .reduce((subSum, s) => subSum + s.stock, 0),
                0,
              ),
          );
        });

        totalRow.push(
          CompanyStore.productStock
            .filter((ps) =>
              ps.stocks.some((s) => s.companyId == ww.companyStoreCompanyId),
            )
            .reduce(
              (sum, ps) =>
                sum +
                ps.stocks
                  .filter((s) => s.companyId == ww.companyStoreCompanyId)
                  .reduce((subSum, s) => subSum + s.stock, 0),
              0,
            ),
        );
      });

      sheetData.push(totalRow);

      // --- ایجاد شیت و دانلود ---
      const ws = XLSX.utils.aoa_to_sheet(sheetData);

      const date = new Date();
      const jDate = jalaali.toJalaali(date);

      const jalaaliDateString = `${jDate.jy}-${String(jDate.jm).padStart(
        2,
        "0",
      )}-${String(jDate.jd).padStart(2, "0")}`;
      const timeString = `${String(date.getHours()).padStart(2, "0")}-${String(
        date.getMinutes(),
      ).padStart(2, "0")}-${String(date.getSeconds()).padStart(2, "0")}`;

      const finalName = `${jalaaliDateString}_${timeString}`;

      XLSX.utils.book_append_sheet(wb, ws, finalName);

      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });

      saveAs(data, `${finalName}.xlsx`);
    } catch (error) {
      console.log(error);
    }
  };

  const start = async () => {
    try {
      const CompanyManageMyStoreData = await CompanyManageMyStore();
      if (
        CompanyManageMyStoreData.status &&
        CompanyManageMyStoreData.status === 200
      ) {
        setStores(CompanyManageMyStoreData.data.data);
        for (const item of CompanyManageMyStoreData.data.data) {
          const CompanyManageGetAutoStockData = await CompanyManageGetAutoStock(
            item.companyStoreId,
          );
          if (
            CompanyManageGetAutoStockData.status &&
            CompanyManageGetAutoStockData.status === 200
          ) {
            if (CompanyManageGetAutoStockData.data.isSuccess) {
              toast.success(
                ` ارتباط با انبار برای موجودی برقرار شد 
                ${item.companyStoreCompanyName} ${item.companyStoreName}`,
              );
            }
          }
        }
      }

      const CompanyManageGetStockAllData = await CompanyManageGetStockAll();
      if (
        CompanyManageGetStockAllData.status &&
        CompanyManageGetStockAllData.status === 200
      ) {
        setCompanyStore(CompanyManageGetStockAllData.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const groupProducts = (products) => {
    const groups = {};
    products
      .filter((itemPro) => {
        const productFilter = Product?.toUpperCase?.() || ""; // برای اطمینان از عدم خطا

        const Pro = [
          itemPro.productProductBerandName != " " &&
            itemPro.productProductBerandName + " ",

          itemPro.productProductTypeName != " " &&
            itemPro.productProductTypeName + " ",

          itemPro.productProductSeriesName != " " &&
            itemPro.productProductSeriesName,

          itemPro.productSymbol,

          itemPro.productProductSeriesEndName != " "
            ? itemPro.productProductSeriesEndName + " "
            : " ",

          itemPro.productProductRamName != " " &&
            itemPro.productProductRamName + "/",

          itemPro.productProductRomName != " " &&
            itemPro.productProductRomName + " ",

          itemPro.productProductNetworkName != " " &&
            itemPro.productProductNetworkName + " ",

          itemPro.productProductCountryName != " " &&
            itemPro.productProductCountryName + " ",

          itemPro.productIsInsurance && "بیمه",
        ]
          .filter(Boolean)
          .join("")
          .toUpperCase();

        return Pro.includes(productFilter);
      })
      .forEach((p) => {
        const key = [
          p.productProductBerandId,
          p.productProductTypeId,
          p.productProductSeriesId,
          p.productSymbol,
          p.productProductSeriesEndId,
          p.productProductRamId,
          p.productProductRomId,
          p.productProductNetworkId,
          p.productProductCountryId,
          p.productIsInsurance,
        ].join("-");
        if (!groups[key]) {
          groups[key] = [];
        }
        groups[key].push(p);
      });
    return Object.values(groups);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
          <button
            className={"m-2 border-0 rounded bg-warning pointer"}
            onClick={() => {
              handleDownload();
            }}
          >
            <img height={40} src={imgPlus} alt="" />
          </button>
          <div className="d-flex">
            <InputCus
              className="m-2"
              type="text"
              name="name"
              id="name"
              text="نام"
              value={Product}
              onChange={(e) => {
                setProduct(e.target.value);
              }}
            />
          </div>
          <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
            {CompanyStore.companyStore && (
              <div className="w-100">
                <div className="d-flex justify-content-center align-items-center w-100 tableC">
                  <table
                    className="table tableMore"
                    style={{ lineHeight: "normal" }}
                  >
                    <thead className="sticky-header">
                      <tr className="trTable">
                        <th rowSpan={2}>سیمبل کالای</th>
                        <th rowSpan={2}>رنگ</th>
                        {Object.values(
                          Stores.reduce((acc, item) => {
                            acc[item.companyStoreCompanyId] = item;
                            return acc;
                          }, {}),
                        ).map((itemPro, index) => (
                          <>
                            <th
                              key={index}
                              colSpan={
                                CompanyStore.companyStore.filter(
                                  (w) =>
                                    w.companyId ==
                                    itemPro.companyStoreCompanyId,
                                ).length
                              }
                            >
                              {itemPro.companyStoreCompanyName}
                            </th>
                            <th rowSpan={2}>مجموع شرکت</th>
                          </>
                        ))}
                      </tr>
                      <tr className="trTable">
                        {Object.values(
                          Stores.reduce((acc, item) => {
                            acc[item.companyStoreCompanyId] = item;
                            return acc;
                          }, {}),
                        ).map((ww) =>
                          CompanyStore.companyStore
                            .filter(
                              (w) => w.companyId == ww.companyStoreCompanyId,
                            )
                            .map((itemPro) => <th>{itemPro.name}</th>),
                        )}
                      </tr>
                    </thead>
                    {CompanyStore.productStock &&
                      groupProducts(CompanyStore.productStock).map(
                        (group, gIndex) => (
                          <tbody key={gIndex}>
                            {group.map((itemPro, iIndex) => {
                              return (
                                <tr key={itemPro.id}>
                                  {iIndex === 0 && (
                                    <>
                                      <td rowSpan={group.length}>
                                        {itemPro.productProductBerandName !=
                                          " " &&
                                          itemPro.productProductBerandName +
                                            " "}
                                        {itemPro.productProductTypeName !=
                                          " " &&
                                          itemPro.productProductTypeName + " "}
                                        {itemPro.productProductSeriesName !=
                                          " " &&
                                          itemPro.productProductSeriesName}
                                        {itemPro.productSymbol}
                                        {itemPro.productProductSeriesEndName !=
                                        " "
                                          ? itemPro.productProductSeriesEndName +
                                            " "
                                          : " "}
                                        {itemPro.productProductRamName != " " &&
                                          itemPro.productProductRamName + "/"}
                                        {itemPro.productProductRomName != " " &&
                                          itemPro.productProductRomName + " "}
                                        {itemPro.productProductNetworkName !=
                                          " " &&
                                          itemPro.productProductNetworkName +
                                            " "}
                                        {itemPro.productProductCountryName !=
                                          " " &&
                                          itemPro.productProductCountryName +
                                            " "}
                                        {itemPro.productIsInsurance && "بیمه"}
                                      </td>
                                    </>
                                  )}
                                  <td>{itemPro.productProductColorName}</td>
                                  {Object.values(
                                    Stores.reduce((acc, item) => {
                                      acc[item.companyStoreCompanyId] = item;
                                      return acc;
                                    }, {}),
                                  ).map((ww) => (
                                    <>
                                      {CompanyStore.companyStore
                                        .filter(
                                          (w) =>
                                            w.companyId ==
                                            ww.companyStoreCompanyId,
                                        )
                                        .map((ee) => (
                                          <td key={ee.id}>
                                            {(() => {
                                              const stock = itemPro.stocks.find(
                                                (w) =>
                                                  w.companyStoreId === ee.id,
                                              )?.stock;
                                              return stock === 0 ||
                                                stock == null
                                                ? "-"
                                                : stock;
                                            })()}
                                          </td>
                                        ))}
                                      <td>
                                        {(() => {
                                          const test = itemPro.stocks.filter(
                                            (w) =>
                                              w.companyId ==
                                              ww.companyStoreCompanyId,
                                          );
                                          const totalStock = itemPro.stocks
                                            .filter(
                                              (w) =>
                                                w.companyId ==
                                                ww.companyStoreCompanyId,
                                            )
                                            .reduce(
                                              (sum, x) => sum + x.stock,
                                              0,
                                            );

                                          return totalStock === 0
                                            ? "-"
                                            : totalStock;
                                        })()}
                                      </td>
                                    </>
                                  ))}
                                </tr>
                              );
                            })}
                          </tbody>
                        ),
                      )}
                    <tbody>
                      <tr>
                        <td className="bg-body-secondary" colSpan={2}>
                          مجموع
                        </td>

                        {(() => {
                          const storeValues = Object.values(
                            (Stores || []).reduce((acc, item) => {
                              if (item && item.companyStoreCompanyId) {
                                acc[item.companyStoreCompanyId] = item;
                              }
                              return acc;
                            }, {}),
                          );
                          const totalRow = [];

                          storeValues.forEach((ww) => {
                            const subStores = CompanyStore.companyStore.filter(
                              (w) => w.companyId == ww.companyStoreCompanyId,
                            );
                            subStores.forEach((ee) => {
                              totalRow.push(
                                CompanyStore.productStock
                                  .filter((ps) =>
                                    ps.stocks.some(
                                      (s) => s.companyStoreId == ee.id,
                                    ),
                                  )
                                  .reduce(
                                    (sum, ps) =>
                                      sum +
                                      ps.stocks
                                        .filter(
                                          (s) => s.companyStoreId == ee.id,
                                        )
                                        .reduce(
                                          (subSum, s) => subSum + s.stock,
                                          0,
                                        ),
                                    0,
                                  ),
                              );
                            });
                            totalRow.push(
                              CompanyStore.productStock
                                .filter((ps) =>
                                  ps.stocks.some(
                                    (s) =>
                                      s.companyId == ww.companyStoreCompanyId,
                                  ),
                                )
                                .reduce(
                                  (sum, ps) =>
                                    sum +
                                    ps.stocks
                                      .filter(
                                        (s) =>
                                          s.companyId ==
                                          ww.companyStoreCompanyId,
                                      )
                                      .reduce(
                                        (subSum, s) => subSum + s.stock,
                                        0,
                                      ),
                                  0,
                                ),
                            );
                          });
                          return totalRow.map((ir) => <td>{ir}</td>);
                        })()}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
export default CompanyStoreStockAll;
